<agr-page-toolbar
  [pageTitle]="'title' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="openApplicationGroupDialog()"
  [isEmpty]="(selectedApplicationGroups | async)?.length === 0"
  [emptyTitle]="'no_authorizations' | translate"
  [showEmptyAction]="true"
  emptyActionIcon="add"
  [emptyActionText]="'add' | translate"
  (emptyAction)="openApplicationGroupDialog()"
  emptyActionColor="accent"
>
  @for (group of selectedApplicationGroups | async; track group) {
    <section data-test="authorizations">
      <div class="button-title wrapper--spacing-horizontal">
        <h2 class="text--h6">{{ group.displayName }}</h2>
        <button (click)="deleteGroupUseraccess(group.id)" mat-stroked-button>
          <mat-icon aria-label="Remove">delete</mat-icon> {{ 'remove' | translate }}
        </button>
      </div>
      <mat-table [dataSource]="getApplications(group.id)">
        <ng-container matColumnDef="name">
          <mat-cell *matCellDef="let application" class="flex__child-1">
            <div
              [ngClass]="{
                'text--light': application.disallowedAccess?.profileTypes?.includes(
                  profileType$ | async
                ),
              }"
            >
              {{ application.displayName }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="set">
          <mat-cell *matCellDef="let application" class="mat-input-cell flex__child-3">
            <mat-form-field class="full-width-field" style="margin-top: 20px">
              <mat-select
                [placeholder]="'role' | translate"
                [ngModel]="getSelectedRole(application.key) | async"
                (ngModelChange)="setUseraccess(application.key, $event)"
                [disabled]="
                  application.disallowedAccess?.profileTypes?.includes(profileType$ | async)
                "
              >
                @for (role of roles | async; track role) {
                  <mat-option [value]="role.key">
                    {{ role.displayName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <mat-row
          *matRowDef="let row; columns: ['name', 'set']"
          style="
            border-bottom-color: rgba(0, 0, 0, 0.12);
            border-bottom-style: solid;
            border-bottom-width: 0.8px;
          "
        ></mat-row>
      </mat-table>
    </section>
  }
</agr-page-toolbar>
